
import Vue from "vue";
import { MessagesService } from "@/services/messages-service";
import { IMail } from "@/utils/mail";
import { DossierConfigService } from "@/services/dossier-config-service";
import { AuthService } from "@/services";
import { MailSettings } from "@/models/mail-settings";
import { MailSettingsService } from "@/services/mail-settings-service";

export default Vue.extend({
	data() {
		return {
			settings: DossierConfigService.getPluginConfig(),
			mailSettings: new MailSettings(),
			mailData: {
				from: "",
				name: "",
				to: "",
				subject: "",
				body: "",
				attachments: [],
				isHTML: true,
				bcc: "",
				cc: ""
			} as IMail,
		};
	},
	props: {
		link: String,
	},
	computed: {
		input(): HTMLInputElement {
			return (this.$refs.input as any).inputElement as HTMLInputElement;
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		download() {
			this.$emit("download");
		},
		async send() {
			try {
				await MessagesService.sendMail(this.mailData, this.mailSettings);
				this.$emit("sent", this.mailData.to);
				this.$wf.notify(
					this.$ct("success"),
					"success",
					3500,
					"exclamation-triangle"
				);
				this.$emit("close");
			} catch (e) {
				if(!AuthService.wfCompany.IsDemo){
					this.$wf.notify(
						this.$ct("error.500"),
						"danger",
						3500,
						"exclamation-triangle"
					);
				}
			}
		},
		isAllowed(): Boolean {
			return true;
			//return AuthService.hasModule(83);
		},

	},
	async mounted() {
		this.mailSettings = await MailSettingsService.getDefaultSettings();
		if (!this.mailData.from || this.mailData.from.match(/^\s*$/)) {
			this.mailData.from = this.mailSettings.EmailFrom || this.mailSettings.Email;
			this.mailData.name = this.mailSettings.EmailName;
		}
		this.mailData.bcc = this.mailSettings.DefaultBCCEmail || "";
		this.mailData.cc = this.mailSettings.DefaultCCEmail || "";
		this.mailData.subject = this.$ct("subject").toString();
		this.mailData.body = this.$ct("message",{link: this.link}).toString();
		this.mailData.to = this.settings.UBL.BookkeeperEmailArchives || "";
	},
	components: {
		VueEditor: () => import("@/utils/vue-editor")
	},
	i18nEx: {
		componentPrefix: "components.ubl-send-modal"
	}
});
